module.exports = __webpack_public_path__ + "img/no-data.d3902fc3.png";